import WorkClient from '../api/workClient';

const getProjectsByCategory = (categoryId: string | undefined) => {
  return WorkClient.getAllProjectsByCategory(categoryId);
};

const getProjectByWorkTaskId = (workTaskId: number) => {
  return WorkClient.getProjectByWorkTaskId(workTaskId);
};

const ProjectsService = {
  getProjectsByCategory,
  getProjectByWorkTaskId
};

export default ProjectsService;
